import Phaser from 'phaser';
import type { StageModel } from '../types';
import { createStageView } from './stage-view';

export function createStageComponent(scene: Phaser.Scene, model: StageModel) {
  const view = createStageView(scene, model);

  return {
    root: view.root,
    setModel: view.setModel,
    syncFromScroll: view.syncFromScroll,
    update: view.update,
    destroy: view.destroy,
  };
}

export { queueStageLoad } from './stage-load';
